import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RateCardEditModeModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=-XLQj7i1mvw&ab_channel=apadua" />
);

export default RateCardEditModeModal;
